import React from 'react';
import {observer} from 'mobx-react';
import {BottomNavigationBarContainerBox} from "./boxes/container/bottom-navigation-bar-container.box";
import {BottomNavigationBarMenuItemsListComponent} from "./bottom-navigation-bar-menu-items-list.component";
import {CyClass} from "../../../common/cy-classes";
import classNames from 'classnames';
import {HYBRID_EMBEDDED_NAV_MENU} from "./bottom-navigation-bar-consts";
import {SpacerBox} from '../../basic-ui-components/layout/spacer.box';
import {BottomNavigationBarMenuItemsContainerBox} from "./boxes/container/bottom-navbar-menu-item-container.box";
import {useServices} from '../../react-hooks/use-services.hook';
import {ComponentServicesPick} from "../../services/component-services-pick";
import {withServices} from "../../react-hooks/with-services";

interface BottomNavigationBarComponentProps extends ComponentServicesPick<'bottomNavigationBar'> {
    isInVideoSlidesArena?: boolean;
}

const ComponentBody: React.FC<BottomNavigationBarComponentProps> = observer((props) => {
    const services = useServices();

    if (!props.bottomNavigationBar.isBottomNavigationEnabled && !Boolean(props.isInVideoSlidesArena)) {
        return null;
    }

    return (
        <>
            <SpacerBox height='8.2rem' style={{marginBottom: "env(safe-area-inset-bottom)"}} />
            <BottomNavigationBarContainerBox shouldElevate={services.spinner.isSpinning}
                className={classNames(HYBRID_EMBEDDED_NAV_MENU, CyClass('cy-hybrid-embedded-nav-menu'))}>
                <BottomNavigationBarMenuItemsContainerBox>
                    <BottomNavigationBarMenuItemsListComponent />
                </BottomNavigationBarMenuItemsContainerBox>
            </BottomNavigationBarContainerBox>
        </>
    );
});

export const BottomNavigationBarComponent = withServices(ComponentBody, ['bottomNavigationBar']);